import { Errors } from 'form-backend-validation';
import { DateTime } from 'luxon';

export default {
    data() {
        return {
            AppData: window.App,
            // Shared data such as: current user
            shared: {
                auth: {
                    user: {
                        id: null,
                    },
                },
            },
            errors: new Errors(),
        };
    },
    created() {
        this.shared = { ...window.shared };
    },
    computed: {
        isDesktop() {
            return document.body.dataset.display === 'desktop';
        },
        isMobile() {
            return !this.isDesktop;
        },
        currentUser() {
            if (this.isLoggedIn()) {
                return this.shared.auth.user.id;
            }

            return null;
        },
        currentStudio() {
            return this.shared.auth.user.last_studio ? this.shared.auth.user.last_studio.id : this.shared.auth.user.favorite_studio.id;
        },
        currentStudioSlug() {
            return this.shared.auth.user.last_studio ? this.shared.auth.user.last_studio.slug : this.shared.auth.user.favorite_studio.slug;
        },
    },
    methods: {
        // Load Ziggy into Vue so it can be accessed within mustache tags
        route: window.route,
        // Mixin for accessing media by relative path within mustache tags
        asset(path) {
            return window.App.mediaPath + path.trim().replace(/^\/+/, '');
        },
        now() {
            return DateTime.local().toISO();
        },
        yesterday() {
            return DateTime.local().minus({ days: 1 }).startOf('day').toISO();
        },
        loadErrors(error) {
            if (error.response && error.response.data && error.response.data.errors) {
                this.$root.errors = new Errors(error.response.data.errors);
            }
        },
        clearErrors(error) {
            this.$root.errors.clear(error);
        },
        isLoggedIn() {
            return this.shared.auth && this.shared.auth.user && this.shared.auth.user.id;
        },
        isClockedIn() {
            return this.shared.auth && this.shared.auth.user && this.shared.auth.user.isClockedIn;
        },
        inRole(...roles) {
            if (this.isLoggedIn()) {
                return this.shared.auth.user.roles.some((r) => roles.includes(r));
            }

            return false;
        },
        notInRole(...roles) {
            return !this.inRole(roles);
        },
        can(...permissions) {
            if (this.isLoggedIn()) {
                return this.shared.auth.user.permissions.some((p) => permissions.includes(p)) || this.inRole('Admin');
            }

            return false;
        },
        cannot(...permissions) {
            return !this.can(permissions);
        },
        userInRole(user, ...roles) {
            return user.roles.some((r) => roles.includes(r));
        },
        userNotInRole(user, ...roles) {
            return !this.userInRole(user, roles);
        },
        userCan(user, ...permissions) {
            return user.permissions.some((p) => permissions.includes(p)) || this.userInRole(user, 'Admin');
        },
        userCannot(user, ...permissions) {
            return !this.userCan(user, permissions);
        },
    },
};
